import type { BestBacktestArtifactUniverseMode, TradingProfile } from '@einhaus/project314-types';

export interface BestBacktestEvidenceModeDetails {
    modalLabel: string;
    resultLabel: string;
    description: string;
    isResearchOnly: boolean;
}

export const BEST_BACKTEST_EVIDENCE_MODE_DETAILS: Record<BestBacktestArtifactUniverseMode, BestBacktestEvidenceModeDetails> = {
    strict_operational: {
        modalLabel: 'Strict historical evidence',
        resultLabel: 'Strict historical evidence',
        description:
            'Uses only cohort snapshots that were available at each simulated entry. Best for checking whether the run could have matched live trading. The run stops if historical snapshot coverage is missing.',
        isResearchOnly: false
    },
    trade_cutoff_reconstruction: {
        modalLabel: 'Reconstructed evidence (research only)',
        resultLabel: 'Reconstructed evidence · research only',
        description:
            'Rebuilds daily rankings from trades completed by each simulated date, but may use exit and option configurations created later. Use only for retrospective research.',
        isResearchOnly: true
    }
};

export const profileUsesCohortBestBacktestSelection = (
    tradingProfile: Pick<TradingProfile, 'backtestSelectionScope'> | null | undefined | void
): boolean => {
    const selectionScope = tradingProfile?.backtestSelectionScope ?? 'entity';

    return selectionScope === 'entityList' || selectionScope === 'allEntities';
};

export const backtestUsesCohortBestBacktestSelection = (
    strategies: readonly { tradingProfile?: Pick<TradingProfile, 'backtestSelectionScope'> | null | void }[]
): boolean => strategies.some((strategy) => profileUsesCohortBestBacktestSelection(strategy.tradingProfile));
